<template>
  <div class="root feature">
    <v-container :class="{ fixed: isDesktop }">
      <div
        :class="$vuetify.breakpoint.mdAndUp ? 'space-bottom' : 'space-bottom-short'"
        v-for="(item, i) in $t('copy.features')"
        :key="'feature' + i"
      >
        <v-row v-if="i % 2 === 0" :class="[isMobile ? 'column-reverse' : 'row']">
          <v-col cols="12" md="6">
            <figure class="figure screen">
              <ScreenSlider v-if="Array.isArray(item.img)"></ScreenSlider>
              <img v-else :src="item.img" />
            </figure>
          </v-col>

          <v-col md="6" cols="12">
            <div class="desc">
              <TitleMain :align="isMobile ? 'center' : 'left'">
                {{ item.title }}
              </TitleMain>
              <div class="desc-content">
                <div class="text use-text-subtitle2 mb-0 text-left" v-html="item.content"></div>
              </div>
              <!-- <v-btn color="primary" large class="btn">
                <span v-t="'See Detail'" />
              </v-btn> -->
            </div>
          </v-col>
        </v-row>

        <v-row v-else>
          <v-col md="6" cols="12">
            <div class="desc">
              <TitleMain :align="isMobile ? 'center' : 'left'">
                <h2>{{ item.title }}</h2>
              </TitleMain>
              <div class="desc-content">
                <div class="text use-text-subtitle2 mb-0 text-left" v-html="item.content"></div>
              </div>
              <!-- <div :class="[isMobile ? 'text-center' : 'text-left']">
                <v-btn color="primary" large class="btn">
                  <span v-t="'See Detail'" />
                </v-btn>
              </div> -->
            </div>
          </v-col>
          <v-col md="6" cols="12">
            <figure class="figure screen">
              <ScreenSlider v-if="Array.isArray(item.img)"></ScreenSlider>
              <img v-else :src="item.img" />
            </figure>
          </v-col>
        </v-row>
      </div>

      <!-- <FeatureTabs></FeatureTabs> -->
    </v-container>
  </div>
</template>

<style lang="scss">
@import "@/landing/dependencies.scss";

.root.feature {
  position: relative;

  @include breakpoints-down(sm) {
    .desc-content {
      display: flex;
      justify-content: center;
    }
  }
  .text {
    margin-bottom: $spacing5;
    max-width: 520px;
  }
  h6 {
    margin-bottom: $spacing5;
  }
  .parallax-wrap {
    .Masthead {
      overflow: visible;
      min-height: 80vh;
      @include breakpoints-down(xs) {
        min-height: 30vh;
      }
    }
    @include breakpoints-up(md) {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
    @include breakpoints-down(sm) {
      margin: spacing(3, 0);
    }
    @include breakpoints-down(xs) {
      margin: 0;
    }
  }
  .figure {
    transform-style: preserve-3d;
    overflow: hidden;
    @include shadow3;
    border-radius: $rounded-medium;
    background: $palette-common-white;
    padding: $spacing1;
    // padding-top: $spacing3;
    margin: $spacing1;
    img {
      width: 100%;
      border-radius: 6px;
      border: 1px solid #eee;
    }
  }

  .screen {
    position: relative;
    img {
      width: 100%;
      display: block;
    }
  }
}
</style>

<script>
import ScreenSlider from "./ScreenSlider.vue";
import SecondaryTitle from "../MainTitle/SecondaryTitle.vue";
import FeatureTabs from "./FeatureTabs.vue";
import imgAPI from "@/landing/static/images/imgAPI";
import Title from "../MainTitle";

export default {
  components: {
    TitleMain: Title,
    FeatureTabs,
    SecondaryTitle,
    ScreenSlider,
  },
  data() {
    return {
      imgAPI: imgAPI,
    };
  },
  computed: {
    isDesktop() {
      return !this.$vuetify.breakpoint.mdAnUp;
    },
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
};
</script>
